import { Heading, HeadingProps } from "@lomarengas/design-system";
import { ReactPropTypes } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import EditorWidget from "./EditorWidget";
import PageListWidget from "./PageListWidget";
import { PageData } from "../../types/InfoWebTypes";

interface WidgetAreaProps {
  pageData?: PageData;
}

const WidgetArea = ({ pageData }: WidgetAreaProps) => {
  if (!pageData) {
    return null;
  }

  const widgets = pageData.content.FlowPart?.Widgets;

  return (
    <div>
      {widgets?.length > 0 && (
        <Row className="g-md-40">
          {widgets.map((widget) => {
            const showTitle =
              widget.WidgetSettingsPart?.ShowTitle?.Value ?? false;
            const cssClass = widget.WidgetSettingsPart?.CssClass?.Text;
            let headingLevel = 3;

            if (widget.WidgetSettingsPart?.TitleType?.Text) {
              headingLevel = widget.WidgetSettingsPart.TitleType.Text.replace(
                "H",
                "",
              );
            }

            return (
              <Col key={"w-" + widget.ContentItemId} className={cssClass}>
                <div className="h-100 d-flex flex-column">
                  {showTitle && widget.DisplayText && (
                    <Heading
                      Level={headingLevel as any}
                      Title={widget.DisplayText}
                    />
                  )}

                  <Card className="h-100">
                    <Card.Body>
                      {widget.ContentType == "EditorWidget" && (
                        <EditorWidget widget={widget} />
                      )}

                      {widget.ContentType == "PageListWidget" && (
                        <PageListWidget widget={widget} />
                      )}
                    </Card.Body>
                  </Card>
                </div>
              </Col>
            );
          })}
        </Row>
      )}
    </div>
  );
};

export default WidgetArea;
export type { WidgetAreaProps };
